import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ProcessSection from './components/ProcessSection';
import CTASection from './components/CTASection';
import TakeoffServices from './components/TakeoffServices';
import ToolsSection, { type Tool } from '../../components/feature/ToolsSection';

const takeoffTools: Tool[] = [
  {
    name: 'D Tools Cloud',
    description: 'Advanced cloud-based quoting platform featuring image quoting, interconnect capabilities, and real-time collaboration.',
    icon: 'ri-cloud-line',
    color: 'from-sky-400 to-blue-500'
  },
  {
    name: 'iPoint',
    description: 'The ultimate end-to-end business management for AV professionals, streamlining everything from sales to service.',
    icon: 'ri-pulse-line',
    color: 'from-orange-500 to-red-500'
  },
  {
    name: 'Portal.io',
    description: 'Industry-leading item sourcing and proposal platform designed specifically for integrated low-voltage systems.',
    icon: 'ri-rocket-line',
    color: 'from-green-500 to-teal-600'
  },
  {
    name: 'Lutron Canvas',
    description: 'Precise design and specification tool for Lutron\'s luxury lighting control and automated shading systems.',
    icon: 'ri-artboard-2-line',
    color: 'from-purple-500 to-pink-500'
  }
];

export default function ServicesPage() {

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        <TakeoffServices />
        <ToolsSection
          title="Specialized Estimation & Quoting Stack"
          description="We utilize industry-leading proposal and design software to ensure our takeoffs integrate perfectly with your business workflow."
          tools={takeoffTools}
        />
        <ProcessSection serviceType="takeoff" />
        <CTASection serviceType="takeoff" />
      </main>
      <Footer />
    </div>
  );
}